module.exports = __webpack_public_path__ + "static/img/schoolCount.ff38de1c.png";